setup(function(options) {
  options.test = 'reboot';
  options.phase = 'reboot';
});
